import { Col, Container, Row, Box } from "./Grid.styled";
var Grid = {
  Col: Col,
  Container: Container,
  Row: Row,
  Box: Box
};
export default Grid;